
import React from 'react'
const CBListItem = ({children, icon, chip,multiclick=false,border=true, bottomBorder=false, onClick=(e=> console.log("hi")),borderLight=false, blockClick=false}) => {
    
  if(multiclick){
    return <div 
   className={`font-sarabun text-lg text-neutral_4 ${border && 'border'} ${bottomBorder && 'border-b'} ${borderLight ? '' : 'border-neutral_2 hover:border-neutral_2'} rounded-sm   pt-2 pb-2 pl-4 pr-4 flex space-x-3 items-center ${blockClick ? '': 'cursor-pointer'}`}>
     <div>{children}</div>
     <div className="flex-grow"></div>
     <div onClick={e=>{
       if(multiclick) {
         onClick(e)
       }
     }} className="justify-self-end">
       {icon}
       </div></div>
  } else {
  return <div 
     onClick={e => {
      if(!multiclick) {
        onClick(e)
      }
     
    }} 
    className={`font-sarabun text-lg text-neutral_4 ${border && 'border'} ${bottomBorder && 'border-b'} ${borderLight ? '' : 'border-neutral_2 hover:border-neutral_2'} rounded-sm   pt-2 pb-2 pl-4 pr-4 flex space-x-3 items-center ${blockClick ? '': 'cursor-pointer'}`}>
      <div>{children}</div>
      <div className="flex-grow"></div>
      <div onClick={e=>{
        if(multiclick) {
          onClick(e)
        }
      }} className="justify-self-end">
        {icon}
        </div></div>
  }
  
  }

  const CBList = ({children,borderLight=false, border=true}) => {
    const childCount = children == null ? 0 : children.length  - 1
    return <ul className={`border ${border ? borderLight ? '' : 'border-neutral_2' :''} rounded-sm`}>
      {
          React.Children.map(children, (child,i) => {
              
            return React.cloneElement(child, {
              border: false,
              bottomBorder: i != childCount
            });
          })
        }
    </ul>
  }
  export { CBList, CBListItem }
